export const TERMS_AND_CONDITIONS = "termsAndConditions"
